import { render, staticRenderFns } from "./SkuInfo.vue?vue&type=template&id=89dd7c22&scoped=true&"
import script from "./SkuInfo.vue?vue&type=script&lang=js&"
export * from "./SkuInfo.vue?vue&type=script&lang=js&"
import style0 from "./SkuInfo.vue?vue&type=style&index=0&id=89dd7c22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd7c22",
  null
  
)

export default component.exports